module.exports = __webpack_public_path__ + "media/images/discover/confirmation/confirmation-image@2x-c7aaf0dd2499576447e91ebe92442a18.png";